<ion-header>
  <ion-toolbar>
    <ion-title slot="start">Campos</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()" [strong]="true">
        <ion-icon name="close"></ion-icon>
        </ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <div class="fields-content">
    <ion-list>
      <ion-item *ngFor="let field of fields">
        <ion-avatar item-start slot="start">
          <img [src]="field.picture" />
        </ion-avatar>
        <div class="ion-list-text-content">
          <div>{{ field.name }}</div>
          <span>{{ field.description }}</span>
        </div>
        <ion-fab-button
          slot="end"
          color="secondary"
          size="small"
          (click)="
            setCenterMap(
              field.position.coordinates[1],
              field.position.coordinates[0],
              field.id
            );
          "
        >
          <ion-icon
            [name]="fieldSelected == field.id ? 'location' : 'locate'"
          ></ion-icon>
        </ion-fab-button>
      </ion-item>
    </ion-list>
  </div>
</ion-content>
